<ion-header>
  <ion-toolbar>
    <ion-title>Actions</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <span ion-text color="primary" when="ios">Cancel</span>
        <ion-icon name="close" showWhen="android, windows"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-item>
    <ion-label>Action: </ion-label>
    <ion-select multiple="false" placeholder="{{'ACTION_TO_COMPLETE' | translate}}"  (ionChange)="changeLayout()"
      [(ngModel)]="config.data">
      <ion-select-option *ngFor="let action of actions" [value]="action">{{action.label}}</ion-select-option>
    </ion-select>
  </ion-item>
  <ng-container *ngIf="config.data">
    <ng-container *ngIf="config.data.key!=='PAGE'">
      <ion-item lines="none">
        <ion-label position="floating">{{config.data.valueLabel || 'La valeur'}}</ion-label>
      </ion-item>
      <ion-item>
        <ion-input placeholder="{{'VALUE' | translate}}" type="text"  [(ngModel)]="config.value"></ion-input>
      </ion-item>
    </ng-container>
    <ion-item *ngIf="config.data.key==='PAGE'">
      <ion-label>Type de page: </ion-label>
      <ion-select multiple="false" placeholder="{{'ACTION_TO_COMPLETE' | translate}}" (ionChange)="changeLayout()"
        [(ngModel)]="config.pageType">
        <ion-select-option value="INTERNAL">INTERNE</ion-select-option>
        <ion-select-option value="EXTERNAL">EXTERNE</ion-select-option>
      </ion-select>
    </ion-item>
    <ng-container *ngIf="config.data.key==='PAGE'">
      <ion-item *ngIf="!readOnly">
        <ion-label position="floating">{{'PAGE_LINK' | translate}}</ion-label>
        <ion-input type="text" [(ngModel)]="config.value"></ion-input>
      </ion-item>
      <ion-item *ngIf="readOnly">
        <ion-label>{{'PAGE_LINK' | translate}}: </ion-label>
        <ion-select multiple="false" placeholder="{{'PAGE_LINK' | translate}}" 
          [(ngModel)]="config.value" *ngIf="config.data.key==='PAGE' && readOnly">
          <ion-select-option *ngFor="let link of internalLinks" [value]="link.deeplink">{{link.label}}</ion-select-option>
        </ion-select>
      </ion-item>
    </ng-container>
    <ng-container *ngIf="showInput">
      <ion-item>
        <ion-label position="floating">{{'Texte bouton' | translate}}</ion-label>
        <ion-input type="text" [(ngModel)]="btnText"></ion-input>
      </ion-item>
    </ng-container>
  </ng-container>
</ion-content>

<ion-footer>
    <ion-button expand="block" color="primary" type="submit" (click)="save()">
      {{'VALIDATE' | translate}}
    </ion-button>
  </ion-footer>